import {
    MenuDropdown,
    MenuDropdownItem,
} from '@instinet-analytics/semantic-ui-components';
import React from 'react';
import './WidgetLegendVisibilitySettings.scss';
import classNames from 'classnames';

export function WidgetLegendVisibilitySettings(props: {
    alignDropdown?: 'left' | 'center' | 'right';
    showSeries?: boolean;
    legendHidden: boolean;
    toggleLegendHidden: () => void;
    toggleShowSeries?: () => void;
}) {
    const {
        alignDropdown,
        legendHidden,
        toggleLegendHidden,
        showSeries,
        toggleShowSeries,
    } = props;

    return (
        <div className="WidgetLegendVisibilitySettings toggle-legend-visibility ui">
            <MenuDropdown
                icon={'cog'}
                text={''}
                alignDropdown={alignDropdown ?? 'center'}
            >
                <div
                    className="legend-visibility-item hide-legend-option"
                    onClick={toggleLegendHidden}
                >
                    <div
                        className={classNames(
                            'ui checkbox',
                            legendHidden && 'checked'
                        )}
                    >
                        <input
                            type="checkbox"
                            checked={legendHidden}
                            onClick={toggleLegendHidden}
                        />
                        <label></label>
                    </div>
                    <MenuDropdownItem
                        text={'Hide Legend (when layout locked)'}
                        onClick={toggleLegendHidden}
                    />
                </div>
                {toggleShowSeries && (
                    <div
                        className="legend-visibility-item hide-series-option"
                        onClick={toggleShowSeries}
                    >
                        <div
                            className={classNames(
                                'ui checkbox',
                                !showSeries && 'checked'
                            )}
                        >
                            <input
                                type="checkbox"
                                checked={!showSeries}
                                onClick={toggleShowSeries}
                            />
                            <label></label>
                        </div>
                        <MenuDropdownItem
                            text={'Hide Chart Series'}
                            onClick={toggleShowSeries}
                        />
                    </div>
                )}
            </MenuDropdown>
        </div>
    );
}
